import { BufferCalculationType } from 'business/BufferCalculationType';
import { ConflictResolutionType } from 'business/models/Models';
import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';
import { FormInputRow } from 'components/input';
import { RMInput } from 'components/main/ProteinFormulation/RMInput';
import { cloneDeep } from 'lodash';
import React, { useEffect } from 'react';
import IngredientsGenericList from '../IngredientsGenericList';
import { IngredientsDetailsProps, KeyValuePairDTO } from '../IngredientsConstants';

const IngredientsDetails = (props: IngredientsDetailsProps) => {
  const {
    conflictResolutionType,
    selectedIngredient,
    setSelectedIngredient,
    selectedTypes,
    setSelectedTypes,
    setSelectedAliases,
    selectedAliases,
    setSelectedCasNumbers,
    selectedCasNumbers,
    setSelectedBufferData,
    selectedBufferData,
    onClickAddTypes,
    onClickAddAliases,
    onClickAddCasNumbers,
    onClickAddBufferData,
    onClickDeleteTypes,
    onClickDeleteAliases,
    onClickDeleteCasNumbers,
  } = props;

  useEffect(() => {
    GetIngredientsDetail();
  }, [selectedIngredient]);

  const selectOrUnselect = (tempItems, item) => {
    item.name = item.name
      ? item.name
      : item.number
      ? item.number
      : item.pH + ' ' + item.ratio;
    const isExist = tempItems.some(
      (type) => type.name === item.name && type.value === conflictResolutionType,
    );
    if (isExist === false) {
      const tempItem: KeyValuePairDTO = new KeyValuePairDTO();
      tempItem.value = conflictResolutionType;
      tempItem.name = item.name ? item.name : item.number;
      tempItem.id = item.id;
      tempItems.push(cloneDeep(tempItem));
    } else {
      const tempItemFiltered = tempItems.filter(
        (type) =>
          type.value !== conflictResolutionType ||
          (type.name !== item.name && type.value == conflictResolutionType),
      );
      tempItems = tempItemFiltered;
    }
    return tempItems;
  };
  const GetIngredientsDetail = () => {
    return (
      <>
        <div id='ingredientsdetails-name-wrapper'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
          }}
        >
          <FormInputRow
            id='ingredientsdetails-input-longname'
            labeltext="Long Name "
            value={selectedIngredient?.longName}
            onChange={(e) => {
              selectedIngredient.longName = e.target.value;
              setSelectedIngredient(selectedIngredient);
            }}
            containerStyle={{ fontSize: '12px', width: '100%' }}
          />
          <FormInputRow
            id='ingredientsdetails-input-shortname'
            labeltext="Short Name "
            value={selectedIngredient?.shortName}
            onChange={(e) => {
              selectedIngredient.shortName = e.target.value;
              setSelectedIngredient(selectedIngredient);
            }}
            containerStyle={{
              fontSize: '12px',
              width: '100%',
              marginLeft: '10px',
            }}
          />
        </div>
        <div id='ingredientsdetails-lists-wrapper' className="flex flex-container">
          <IngredientsGenericList
            name="Type"
            iterator={selectedIngredient?.types}
            selectedItems={selectedTypes}
            onClickAdd={onClickAddTypes}
            onClickDelete={onClickDeleteTypes}
            callbackMethod={setSelectedTypes}
            showAddButton={
              conflictResolutionType === ConflictResolutionType.UseSubstitute
            }
            conflictResolutionType={conflictResolutionType}
            selectOrUnselect={selectOrUnselect}
          />
          <IngredientsGenericList
            name="Aliases"
            iterator={selectedIngredient?.aliases}
            selectedItems={selectedAliases}
            onClickAdd={onClickAddAliases}
            onClickDelete={onClickDeleteAliases}
            callbackMethod={setSelectedAliases}
            conflictResolutionType={conflictResolutionType}
            selectOrUnselect={selectOrUnselect}
          />
          <IngredientsGenericList
            name="CAS#"
            iterator={selectedIngredient?.casnumbers}
            selectedItems={selectedCasNumbers}
            onClickAdd={onClickAddCasNumbers}
            onClickDelete={onClickDeleteCasNumbers}
            callbackMethod={setSelectedCasNumbers}
            conflictResolutionType={conflictResolutionType}
            selectOrUnselect={selectOrUnselect}
          />
          {selectedIngredient?.bufferCalculationTypeId !== null &&
          selectedIngredient?.bufferCalculationTypeId === BufferCalculationType.pKa.ID ? (
            <div id="ingredientsdetails-pka-wrapper">
              <div id="ingredientsdetails-pka-header" className="flex flex-row justify-content-between">
                <p id="ingredientsdetails-pka-label" className="ingredient-pka">PKa</p>
              </div>
              <RMInput
                className="ingredient-pka-field"
                onChange={(e) => {}}
                value={selectedIngredient?.pKa}
              />
            </div>
          ) : (
            <div id="ingredientsdetails-bufferdata-wrapper">
              <RMTableHeadingWithAddRemoveBtns
                tableHeading="Buffer Data"
                onClickAddBtn={() => {
                  onClickAddBufferData(conflictResolutionType);
                }}
                onClickRemoveBtn={() => {}}
              />
              <div id="ingredientsdetails-bufferdata-list" className="wizard-list incoming-ingredients-list">
                {selectedIngredient?.bufferDataPoint?.length > 0 ? (
                  <div id="ingredientsdetails-bufferdata-list-header" className="wizard-list-item sticky-top bg-white">
                    <div id="ingredientsdetails-bufferdata-list-header-ph" className="col-lg-6 float-left fw-bold">PH</div>
                    <div id="ingredientsdetails-bufferdata-list-header-ratio" className="col-lg-6 float-left fw-bold">Ratio</div>
                  </div>
                ) : (
                  <></>
                )}
                {selectedIngredient?.bufferDataPoint?.map((bufferData, i) => {
                  return (
                    <div
                      id={`ingredientsdetails-bufferdata-item-${i}`}
                      key={`bdp${i}`}
                      className={`ingredient-wizard-list-item wizard-list-item ${
                        selectedBufferData.some(
                          (lItem) =>
                            lItem.name === `${bufferData.ph} ${bufferData.ratio}` &&
                            lItem.value === conflictResolutionType,
                        )
                          ? 'wizard-list-item-active'
                          : ''
                      }`}
                      onClick={() => {
                        const tempItems = selectOrUnselect(
                          selectedBufferData,
                          bufferData,
                        );
                        setSelectedBufferData([...tempItems]);
                      }}
                    >
                      <div id={`ingredientsdetails-bufferdata-item-${i}-ph`} className="col-lg-6 float-left">{bufferData.ph}</div>
                      <div id={`ingredientsdetails-bufferdata-item-${i}-ratio`} className="col-lg-6 float-left">{bufferData.ratio}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </>
    );
  };
  return <>{selectedIngredient ? GetIngredientsDetail() : <></>}</>;
};
export default React.memo(IngredientsDetails);
